/**
 * React Query keys for Drive data, so queries and the mutations that invalidate or patch them
 * agree on one shape. Partial keys (e.g. `allFiles`) match every entry of that kind.
 */
export const queryKeys = {
    drives: () => ['drives'] as const,
    allFiles: () => ['files'] as const,
    files: (folderId: string | undefined) => ['files', folderId] as const,
    fileMeta: (fileId: string | undefined) => ['file-meta', fileId] as const,
    comments: (fileId: string | undefined) => ['comments', fileId] as const,
    revisions: (fileId: string | undefined) => ['revisions', fileId] as const,
    /** A JSON file's text; `version` is the file's Drive version, null when the caller doesn't know it. */
    jsonFile: (fileId: string | undefined, version?: string) => ['json', fileId, version ?? null] as const,
    /** Every cached version of one JSON file. */
    jsonFileVersions: (fileId: string) => ['json', fileId] as const,
    /** An album's cover picture, looked up by name in its web bin (see useAlbumCover). */
    albumCover: (webFolderId: string | undefined, fileName: string | undefined) => ['album-cover', webFolderId, fileName ?? null] as const,
    allInfoIndexes: () => ['info-index'] as const,
    /** Every info.json in a shared drive (see useInfoFileIndex). */
    infoIndex: (driveId: string | undefined) => ['info-index', driveId] as const,
};
